import { render, staticRenderFns } from "./PipelineTabs.vue?vue&type=template&id=c720084e&"
import script from "./PipelineTabs.vue?vue&type=script&lang=ts&"
export * from "./PipelineTabs.vue?vue&type=script&lang=ts&"
import style0 from "./PipelineTabs.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports